import React from 'react';
import './style.scss';

function BurgerIcon() {
  return (
    <div className="BurgerIcon">
      <div className="BurgerIcon__line" />
      <div className="BurgerIcon__line" />
      <div className="BurgerIcon__line" />
    </div>
  );
}

export default BurgerIcon;
